import { components } from 'react-select';
import type { GroupBase, OptionProps } from 'react-select';

const { Option: BaseOption } = components;

export type { OptionProps };

const Option = <Option, IsMulti extends boolean, Group extends GroupBase<Option> = GroupBase<Option>>({
    children,
    innerProps,
    ...props
}: OptionProps<Option, IsMulti, Group>) => (
    <BaseOption
        {...props}
        innerProps={
            // We need to cheat here a bit to pass title to the root element for option as it's not officially
            // supported but all innerProps are added to the root element.
            {
                ...innerProps,
                title: typeof children === 'string' ? children : undefined,
                // The built-in hover/focus styling logic for react-select causes performance issues
                // that make select really slow if it contains many options (e.g. >500 options)
                // https://github.com/JedWatson/react-select/issues/3128
                //
                // Instead of these methods we use CSS selectors for hover and focus
                // along with event listeners on the parent container to switch between
                // mouse hover styling and keyboard focus styling
                onMouseMove: () => ({}),
                onMouseOver: () => ({}),
            }
        }
    >
        {children}
    </BaseOption>
);

export default Option;
